import {CONTENT_SUBMISSION_STATUS} from '@/types/contentSubmission';
import {
  CONTENT_SUBMISSION_ACTION,
  type ContentSubmissionAction,
} from '@/components/content-submission-card/contentSubmissionCardTypes';

/**
 * Actions allowed per content submission state.
 * Each UI surface (kebab menu, single-asset footer, table row menu) renders
 * only the subset of these actions that its own item list supports.
 */
export const CONTENT_SUBMISSION_ACTIONS_BY_STATE: Record<
  string,
  readonly ContentSubmissionAction[]
> = {
  [CONTENT_SUBMISSION_STATUS.PENDING]: [
    CONTENT_SUBMISSION_ACTION.SHARE,
    CONTENT_SUBMISSION_ACTION.ACCEPT,
    CONTENT_SUBMISSION_ACTION.ARCHIVE,
    CONTENT_SUBMISSION_ACTION.REJECT,
    CONTENT_SUBMISSION_ACTION.COMMENT,
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
  ],
  [CONTENT_SUBMISSION_STATUS.REJECTED]: [
    CONTENT_SUBMISSION_ACTION.SHARE,
    CONTENT_SUBMISSION_ACTION.ARCHIVE,
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
  ],
  [CONTENT_SUBMISSION_STATUS.APPROVED]: [
    CONTENT_SUBMISSION_ACTION.SHARE,
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
    CONTENT_SUBMISSION_ACTION.RESIZE,
  ],
  [CONTENT_SUBMISSION_STATUS.ARCHIVED]: [
    CONTENT_SUBMISSION_ACTION.SHARE,
    CONTENT_SUBMISSION_ACTION.UNARCHIVE,
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
  ],
};

/** Actions not allowed for mixed-media content submissions. */
export const MIXED_MEDIA_EXCLUDED_CONTENT_SUBMISSION_ACTIONS: readonly ContentSubmissionAction[] =
  [
    CONTENT_SUBMISSION_ACTION.ARCHIVE,
    CONTENT_SUBMISSION_ACTION.ACCEPT,
    CONTENT_SUBMISSION_ACTION.REJECT,
    CONTENT_SUBMISSION_ACTION.COMMENT,
    // Mixed-media parents (Instagram stories) bundle multiple child submissions —
    // there is no single file to download at the parent level. Each child shows
    // its own Download option.
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
  ];

/** Actions not allowed for children of mixed-media content submissions. */
export const MIXED_MEDIA_CHILD_EXCLUDED_CONTENT_SUBMISSION_ACTIONS: readonly ContentSubmissionAction[] =
  [CONTENT_SUBMISSION_ACTION.ARCHIVE];

/** Actions allowed even when the campaign is not in an active state. */
export const INACTIVE_CAMPAIGN_CONTENT_SUBMISSION_ACTIONS: readonly ContentSubmissionAction[] =
  [
    CONTENT_SUBMISSION_ACTION.SHARE,
    CONTENT_SUBMISSION_ACTION.ARCHIVE,
    CONTENT_SUBMISSION_ACTION.UNARCHIVE,
    // Download is a read-only action — safe to allow even after a campaign ends.
    CONTENT_SUBMISSION_ACTION.DOWNLOAD,
  ];
